import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'src/components/Analytics';
import deactivated from '../CountdownToRefundingFlow/svg/deactivated-il.svg';
import Svg from '@jg/svg';

const DonationsRefundedSupporterContent: React.StatelessComponent = () => {
  return (
    <div className="jg-background--white jg-bdb jg-bd--solid jg-bd--very-light-grey jg-space-phmd jg-space-pvlg jg-space-mhn jg-text--center row">
      <div className="col-xs-12 col-md-8 offset-md-2">
        <Svg markup={deactivated} className="jg-svg-sm" />
        <h2>
          <FormattedMessage
            id="DonationsRefundedSupporterContent.pageDeactivated"
            defaultMessage="This Page has been deactivated"
          />
        </h2>
        <p className="jg-space-mbml">
          <FormattedMessage
            id="DonationsRefundedSupporterContent.pageClosed"
            defaultMessage="Unfortunately this Page is now closed. Donations made to this Page will be refunded soon."
          />
        </p>
        <Link
          href="https://help.justgiving.com/hc/en-us/articles/360000300338"
          target="_blank"
          rel="noreferrer noopener"
          analyticsOptions={{
            event: 'link click',
            eventValue: 'learn more',
            pageSection:
              'admin > page view > supporter prompt > page deactivated',
            subtype: 'button',
          }}
        >
          <FormattedMessage
            id="DonationsRefundedSupporterContent.learnMoreLink"
            defaultMessage="Learn more about this"
          />
        </Link>
      </div>
    </div>
  );
};

export default DonationsRefundedSupporterContent;



// WEBPACK FOOTER //
// ./src/components/Prompt/DonationsRefundedSupporter/DonationsRefundedSupporterContent.tsx